import { useRecordContext } from "react-admin";

type Props = {
  /** Words before the record, e.g. "Edit student". */
  prefix: string;
  /** Record fields joined with ", " after the prefix; empty ones are skipped. */
  sources: string[];
};

/** Page title like "Edit student — Fatima Kothari", instead of react-admin's default "Students #<uuid>". */
export function RecordTitle({ prefix, sources }: Props) {
  const record = useRecordContext<Record<string, unknown>>();
  const parts = sources
    .map((s) => record?.[s])
    .filter(
      (v): v is string | number => (typeof v === "string" && v !== "") || typeof v === "number"
    );
  return <span>{parts.length ? `${prefix} — ${parts.join(", ")}` : prefix}</span>;
}
